<span [translate]="'tdWb.lti.step.' + step()"></span>
